export default "__VITE_PUBLIC_ASSET__f79c05b6__"